import { createFileRoute } from '@tanstack/react-router'

import { DemoListPage } from '~/boundedContext/list/pages/demo-list-page'
import { mainListPageSchema } from '~/routes/_main-layout/-schemas/main-list-page-schema'

export const Route = createFileRoute('/demo/_layout/list')({
  component: DemoListPage,
  validateSearch: mainListPageSchema,
})
